import { useState } from 'react';
import { SubpageLayout2018 } from '../subpageLayout';

export default function Highlights2018Zh() {
  const [tab, setTab] = useState<'photo' | 'video'>('photo');
  const [photoGroup, setPhotoGroup] = useState<'awards' | 'others' | 'summit'>('awards');
  const [videoGroup, setVideoGroup] = useState<'overview' | 'guests' | 'winners'>('overview');

  const renderPhotoCard = (img: string, idx: number) => (
    <a key={img} className="gallery" data-type={`/2018/images/${img}`} href={`/2018/images/${img}`}>
      <div className={idx % 2 === 0 ? 'photo_img_container_L' : 'photo_img_container_R'}>
        <div className={idx % 2 === 0 ? 'photo_overlay' : 'photo_overlay2'}></div>
        <div className="photo_enlarge"><img src="/2018/images/enlarge.png" /></div>
        <img src={`/2018/images/${img}`} className="photo_image" />
      </div>
    </a>
  );

  const renderVideoCard = (id: string, idx: number) => (
    <a key={id} className="video" href={`https://www.youtube.com/watch?v=${id}`} target="_blank" rel="noreferrer">
      <div className={idx % 2 === 0 ? 'photo_img_container_L' : 'photo_img_container_R'}>
        <div className={idx % 2 === 0 ? 'photo_overlay' : 'photo_overlay2'}></div>
        <div className="photo_enlarge"><img src="/2018/images/enlarge.png" /></div>
        <img
          src={`https://img.youtube.com/vi/${id}/maxresdefault.jpg`}
          className="photo_image"
          onError={(e) => {
            const target = e.currentTarget;
            if (!target.src.includes('/hqdefault.jpg')) {
              target.src = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
            }
          }}
        />
      </div>
    </a>
  );

  return (
    <SubpageLayout2018 lang="zh" title="花絮" page="highlights">
      <div className="award_categories">
        <div className="awards_para_introduction para_introduction">
          <h1>花絮</h1>
        </div>
      </div>
      <div className="highlights_content_container">
        <div className="highlights_tab">
          <div className="highlights_tab_container">
            <ul className="highlights_tabs">
              <li className={tab === 'photo' ? 'current' : ''}>
                <a href="#" onClick={(e) => { e.preventDefault(); setTab('photo'); }}>相片集</a>
              </li>
              <li className={tab === 'video' ? 'current' : ''}>
                <a href="#" onClick={(e) => { e.preventDefault(); setTab('video'); }}>影片</a>
              </li>
              <li><a target="_blank" rel="noreferrer" href="/2018/Summit_Supplement.pdf">峰會報導</a></li>
              <li><a target="_blank" rel="noreferrer" href="/2018/award_supplement.pdf">得獎報導</a></li>
            </ul>
          </div>
          <div className="highlights_tab_content">
            <div className="tabs_item" style={{ display: tab === 'photo' ? 'block' : 'none' }}>
              <div className="submenu">
                <a className={`photo_submenu submenu_awards ${photoGroup === 'awards' ? 'current2' : ''}`} onClick={() => setPhotoGroup('awards')}>頒獎典禮</a>
                <a className={`photo_submenu submenu_others ${photoGroup === 'others' ? 'current2' : ''}`} onClick={() => setPhotoGroup('others')}>活動花絮</a>
                <a className={`photo_submenu submenu_summit ${photoGroup === 'summit' ? 'current2' : ''}`} onClick={() => setPhotoGroup('summit')}>峰會盛況</a>
              </div>
              <div className="photo_thumbnail" style={{ display: photoGroup === 'awards' ? 'block' : 'none' }}>
                {[
                  'awards_DSC_5742.jpg', 'awards_DSC_5489.jpg', 'awards_DSC_5618.jpg', 'awards_DSC_5662.jpg',
                  'awards_OMD11698.jpg', 'awards_OMD11758.jpg', 'awards_OMD11764.jpg', 'awards_OMD11772.jpg',
                  'awards_OMD11790.jpg', 'awards_OMD11803.jpg', 'awards_OMD11841.jpg', 'awards_OMD11855.jpg',
                  'awards_OMD11858.jpg', 'awards_OMD10873.jpg',
                ].map(renderPhotoCard)}
              </div>
              <div className="photo_thumbnail3" style={{ display: photoGroup === 'others' ? 'block' : 'none' }}>
                {[
                  'others_Adam_Lau-MAN_9344.jpg', 'others_Austin_R_BRYAN-MAN_9304.jpg', 'others_Blockchain-MAN_9354.jpg',
                  'others_Cyberport-MAN_9607.jpg', 'others_DHL-MAN_9583.jpg', 'others_DSC_4940.jpg',
                  'others_HKEVN-MAN_9617.jpg', 'others_Infineon-MAN_9505.jpg', 'others_Ingdan+Greensafety-MAN_9512.jpg',
                  'others_KDK-MAN_9623.jpg', 'others_MAN_9625.jpg', 'others_NEC-MAN_9576.jpg',
                  'others_OMD10826.jpg', 'others_OMD10908.jpg', 'others_OMD10915.jpg', 'others_OMD10920.jpg',
                  'others_OMD10921.jpg', 'others_OMD10926.jpg', 'others_OMD10941.jpg', 'others_OMD11586.jpg',
                  'others_Ricacorp-MAN_9488.jpg', 'others_St_Pauls-MAN_9266.jpg', 'others_Tao_Charm+Peter_Yeung-MAN_9381.jpg',
                  'others_Winnie_Tang-MAN_9337.jpg',
                ].map(renderPhotoCard)}
              </div>
              <div className="photo_thumbnail2" style={{ display: photoGroup === 'summit' ? 'block' : 'none' }}>
                {[
                  'summit_DSC_5031.jpg', 'summit_DSC_5259.jpg', 'summit_DSC_5474.jpg', 'summit_DSC_5705.jpg',
                  'summit_OMD10949.jpg', 'summit_OMD10954.jpg', 'summit_OMD11121.jpg', 'summit_OMD11160.jpg',
                  'summit_OMD11317.jpg', 'summit_OMD11325.jpg', 'summit_OMD11326.jpg', 'summit_OMD11377.jpg',
                  'summit_OMD11418.jpg', 'summit_OMD11435.jpg', 'summit_OMD11453.jpg', 'summit_OMD11484.jpg',
                  'summit_OMD11490.jpg', 'summit_OMD11576.jpg', 'summit_OMD11624.jpg', 'summit_OMD11681.jpg',
                ].map(renderPhotoCard)}
              </div>
            </div>
            <div className="tabs_item" style={{ display: tab === 'video' ? 'block' : 'none' }}>
              <div>
                <div className="submenu">
                  <a className={`photo_submenu submenu_awards ${videoGroup === 'overview' ? 'current2' : ''}`} onClick={() => setVideoGroup('overview')}>精彩花絮</a>
                  <a className={`photo_submenu submenu_others ${videoGroup === 'guests' ? 'current2' : ''}`} onClick={() => setVideoGroup('guests')}>星級嘉賓</a>
                  <a className={`photo_submenu submenu_summit ${videoGroup === 'winners' ? 'current2' : ''}`} onClick={() => setVideoGroup('winners')}>得獎公司</a>
                </div>
                <div className="photo_thumbnail video" style={{ display: videoGroup === 'overview' ? 'block' : 'none' }}>
                  {['jfYVK9v5zqs', '_UOZ8pmyuA4'].map(renderVideoCard)}
                </div>
                <div className="photo_thumbnail3 video" style={{ display: videoGroup === 'guests' ? 'block' : 'none' }}>
                  {['OUTTX4h05E8', '8m7_g5znPy4', 'eueWKI7YrUo', 'jYTkJ3Vl3cc', 'T0BVM1FyjDw', 'ElwXM6QWVtw', 'NGZFi5ENw3k', 'XRHC0JkTHe4', 'gjNodOJo45c'].map(renderVideoCard)}
                </div>
                <div className="photo_thumbnail2 video" style={{ display: videoGroup === 'winners' ? 'block' : 'none' }}>
                  {['0P9yxmtEsUU', 'ds4syBUzUz0', 'X6GDTnTCKho', 'jd998bzEQbY', 'WdRE4jv5CJo'].map(renderVideoCard)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

